/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface IneligibleView {
  job_candidate_id: string;
  full_name?: string | null;
  reason: string;
}
